var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"Screen",staticStyle:{"height":"100%"}},[_c('div',{ref:"viz",staticClass:"left",attrs:{"id":"viz"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }